import { Star, StarOff } from "lucide-react";
import { useT } from "../../../../i18n/I18nProvider";

/** The one entry a rail row's right-click menu has: pin it to Favorites, or take the pin off. */
export function PinItem({ pinned, onToggle, close }: { pinned: boolean; onToggle: () => void; close: () => void }) {
  const t = useT();
  return (
    <button
      type="button"
      className="crm-mi"
      onClick={() => {
        close();
        onToggle();
      }}
    >
      {pinned ? <StarOff className="size-4" /> : <Star className="size-4" />}
      {t(pinned ? "mail.fav.unpin" : "mail.fav.pin")}
    </button>
  );
}
